import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

/**
 * Stato dell'offerta early-bird per l'utente loggato (fonte: GET /api/offerta).
 * Il calcolo della finestra è 100% server-side; qui leggiamo solo il risultato.
 */
export function useOffer() {
  const [offer, setOffer] = useState(null); // { attiva, prezzo, scade_il }
  const [loading, setLoading] = useState(true);

  const refetchOffer = useCallback(async () => {
    try {
      const r = await api.get("/offerta");
      setOffer(r.data);
    } catch (_e) {
      setOffer({ attiva: false, prezzo: 39, scade_il: null });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetchOffer();
  }, [refetchOffer]);

  return { offer, loading, refetchOffer, setOffer };
}

/** Conto alla rovescia fino a scade_il, formato "HH:MM" (null se scaduto/assente). */
export function formatCountdown(scadeIl) {
  if (!scadeIl) return null;
  const diff = new Date(scadeIl).getTime() - Date.now();
  if (diff <= 0) return null;
  const totalMin = Math.floor(diff / 60000);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}
